document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

window.Shopify = window.Shopify || {};
const defaultMoneyFormat = '$' + '{' + '{amount}}';
if (!window.Shopify.formatMoney) {
  window.Shopify.formatMoney = (cents, format = defaultMoneyFormat) => {
    const value = (Number(cents || 0) / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(Number(cents || 0) / 100));
  };
}

const header = document.querySelector('[data-site-header]');
const menuToggle = document.querySelector('[data-menu-toggle]');
const promotionBar = document.querySelector('[data-promotion-bar]');
const promotionMessage = promotionBar?.querySelector('[data-promotion-message]');
const promotionProgress = promotionBar?.querySelector('[data-promotion-progress]');
const cartCount = document.querySelector('[data-cart-count]');
const cartFeedback = document.querySelector('[data-cart-feedback]');
const cartFeedbackMessage = cartFeedback?.querySelector('[data-cart-feedback-message]');
let cartFeedbackTimeout;

const promotionThreshold = Number(promotionBar?.dataset.promotionThreshold || 0);
const promotionPercent = Number(promotionBar?.dataset.promotionPercent || 15);
const promotionMoneyFormat = promotionBar?.dataset.moneyFormat || defaultMoneyFormat;

const promotionStatus = (totalPrice) => {
  const total = Number(totalPrice || 0);
  const remaining = Math.max(promotionThreshold - total, 0);

  if (promotionThreshold > 0 && total >= promotionThreshold) {
    return {
      message: `You unlocked ${promotionPercent}% off`,
      feedback: `Added to cart. You unlocked ${promotionPercent}% off.`,
      progress: 100,
    };
  }

  if (total > 0 && promotionThreshold > 0) {
    const remainingMoney = Shopify.formatMoney(remaining, promotionMoneyFormat);
    return {
      message: `Only ${remainingMoney} away from ${promotionPercent}% off`,
      feedback: `Added to cart. Only ${remainingMoney} more to unlock ${promotionPercent}% off.`,
      progress: Math.min((total / promotionThreshold) * 100, 100),
    };
  }

  return {
    message: `Spend ${Shopify.formatMoney(promotionThreshold, promotionMoneyFormat)}, get ${promotionPercent}% off`,
    feedback: 'Added to cart.',
    progress: 0,
  };
};

const updatePromotion = (cart, announce = false) => {
  if (!cart) return;

  const qualifyingSubtotal = cart.items_subtotal_price ?? cart.total_price;
  const status = promotionStatus(qualifyingSubtotal);
  if (promotionMessage) promotionMessage.textContent = status.message;
  if (promotionProgress) promotionProgress.style.width = `${status.progress}%`;
  if (cartCount) cartCount.textContent = String(cart.item_count || 0);

  if (announce && cartFeedback && cartFeedbackMessage) {
    window.clearTimeout(cartFeedbackTimeout);
    cartFeedbackMessage.textContent = status.feedback;
    cartFeedback.hidden = false;
    cartFeedbackTimeout = window.setTimeout(() => {
      cartFeedback.hidden = true;
    }, 5000);
  }
};

const fetchCart = async () => {
  const root = window.Shopify.routes?.root || '/';
  const response = await fetch(`${root}cart.js`, {
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) throw new Error('Unable to refresh cart');
  return response.json();
};

if (header && menuToggle) {
  menuToggle.addEventListener('click', () => {
    const isOpen = header.classList.toggle('is-open');
    menuToggle.setAttribute('aria-expanded', String(isOpen));
  });
}

if (promotionBar) {
  fetchCart()
    .then((cart) => updatePromotion(cart))
    .catch(() => updatePromotion({
      items_subtotal_price: Number(promotionBar.dataset.cartTotal || 0),
      item_count: Number(cartCount?.textContent || 0),
    }));
}

const cartForm = document.querySelector('[data-cart-form]');
if (cartForm) {
  const quantityInputs = Array.from(cartForm.querySelectorAll('[data-cart-quantity]'));
  const updateButton = cartForm.querySelector('[data-cart-update]');
  const updatingStatus = cartForm.querySelector('[data-cart-updating]');
  let cartUpdateTimer;
  let cartIsSubmitting = false;

  const submitCartUpdate = () => {
    if (cartIsSubmitting || !updateButton) return;

    const hasInvalidQuantity = quantityInputs.some((input) => !input.checkValidity());
    if (hasInvalidQuantity) return;

    cartIsSubmitting = true;
    cartForm.classList.add('is-updating');
    cartForm.setAttribute('aria-busy', 'true');
    if (updatingStatus) updatingStatus.hidden = false;
    quantityInputs.forEach((input) => {
      input.readOnly = true;
    });

    if (typeof cartForm.requestSubmit === 'function') {
      cartForm.requestSubmit(updateButton);
    } else {
      updateButton.click();
    }
  };

  const scheduleCartUpdate = () => {
    window.clearTimeout(cartUpdateTimer);
    cartUpdateTimer = window.setTimeout(submitCartUpdate, 650);
  };

  quantityInputs.forEach((input) => {
    input.addEventListener('input', scheduleCartUpdate);
    input.addEventListener('change', scheduleCartUpdate);
  });
}

document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'add') return;

    event.preventDefault();

    const originalText = submitter.textContent;
    submitter.disabled = true;
    submitter.textContent = 'Adding...';

    try {
      const root = window.Shopify.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Unable to add this item');
      }

      const cart = await fetchCart();
      updatePromotion(cart, true);
      submitter.textContent = 'Added';
    } catch (error) {
      submitter.textContent = error.message || 'Try again';
    } finally {
      window.setTimeout(() => {
        submitter.disabled = false;
        submitter.textContent = originalText;
      }, 1800);
    }
  });
});

document.querySelectorAll('[data-shilajit-pdp-size-picker]').forEach((picker) => {
  const root = picker.closest('[data-product-form-root]');
  const options = Array.from(picker.querySelectorAll('[data-shilajit-pdp-size-option]'));
  const price = root?.querySelector('[data-product-price]');
  const comparePrice = root?.querySelector('[data-product-compare-price]');
  const addButton = root?.querySelector('[data-add-to-cart]');
  const sku = root?.querySelector('[data-product-sku]');
  const purchaseTypes = Array.from(root?.querySelectorAll('[data-shilajit-purchase-type]') || []);
  const sellingPlanSelect = root?.querySelector('[data-shilajit-selling-plan]');
  const sellingPlanSelector = root?.querySelector('[data-shilajit-plan-selector]');
  const oneTimePrice = root?.querySelector('[data-shilajit-one-time-price]');
  const subscriptionPrice = root?.querySelector('[data-shilajit-subscription-price]');

  const syncSellingPlans = (productHandle) => {
    if (!sellingPlanSelect) return;

    const planOptions = Array.from(sellingPlanSelect.options);
    planOptions.forEach((plan) => {
      const isCurrentProduct = plan.dataset.productHandle === productHandle;
      plan.hidden = !isCurrentProduct;
      plan.disabled = !isCurrentProduct;
    });

    const firstPlan = planOptions
      .filter((plan) => !plan.disabled)
      .sort((a, b) => Number(b.dataset.planDiscount || 0) - Number(a.dataset.planDiscount || 0))[0];
    const subscribeOption = purchaseTypes.find((option) => option.value === 'subscription');
    const oneTimeOption = purchaseTypes.find((option) => option.value === 'one-time');

    if (firstPlan) sellingPlanSelect.value = firstPlan.value;
    if (subscribeOption) subscribeOption.disabled = !firstPlan;
    if (!firstPlan && subscribeOption?.checked && oneTimeOption) oneTimeOption.checked = true;
    if (subscriptionPrice) {
      subscriptionPrice.textContent = firstPlan
        ? `${firstPlan.dataset.planDiscount}% off - ${firstPlan.dataset.planPrice}`
        : 'Unavailable';
    }

    const subscriptionSelected = Boolean(firstPlan && subscribeOption?.checked);
    sellingPlanSelect.disabled = !subscriptionSelected;
    if (sellingPlanSelector) sellingPlanSelector.hidden = !subscriptionSelected;
  };

  const syncPurchaseType = () => {
    const selectedSize = options.find((option) => option.checked);
    syncSellingPlans(selectedSize?.dataset.productHandle || '');
  };

  const updateShilajitSize = (option) => {
    if (!option?.checked) return;

    if (price) price.textContent = option.dataset.price;

    if (comparePrice) {
      comparePrice.hidden = !option.dataset.comparePrice;
      comparePrice.textContent = option.dataset.comparePrice || '';
    }

    if (addButton) {
      const isAvailable = option.dataset.available === 'true';
      addButton.disabled = !isAvailable;
      addButton.textContent = isAvailable ? addButton.dataset.availableText : addButton.dataset.soldOutText;
    }

    if (sku) sku.textContent = option.dataset.sku || 'Available at checkout';
    if (oneTimePrice) oneTimePrice.textContent = option.dataset.price;
    syncSellingPlans(option.dataset.productHandle || '');

    const gallery = root?.querySelector('[data-product-gallery]');
    const heroSlide = gallery?.querySelector('[data-gallery-slide]');
    const heroThumbnail = gallery?.querySelector('[data-gallery-thumbnail]');
    const heroImages = [heroSlide?.querySelector('img'), heroThumbnail?.querySelector('img')];
    if (option.dataset.productImage) {
      heroImages.forEach((image) => {
        if (!image) return;
        image.src = option.dataset.productImage;
        image.removeAttribute('srcset');
        image.alt = option.dataset.productTitle || 'Pure Shilajit Resin';
      });
    }
    if (heroSlide && option.dataset.productImageFull) {
      heroSlide.dataset.fullImage = option.dataset.productImageFull;
    }
    heroThumbnail?.click();

    const url = new URL(window.location.href);
    if (option.dataset.productPath) url.pathname = option.dataset.productPath;
    url.searchParams.set('variant', option.dataset.variantId);
    window.history.replaceState({}, '', url.toString());
  };

  options.forEach((option) => {
    option.addEventListener('click', () => updateShilajitSize(option));
  });

  purchaseTypes.forEach((option) => option.addEventListener('change', syncPurchaseType));
  sellingPlanSelect?.addEventListener('change', () => {
    const selectedPlan = sellingPlanSelect.selectedOptions[0];
    if (subscriptionPrice && selectedPlan) {
      subscriptionPrice.textContent = `${selectedPlan.dataset.planDiscount}% off - ${selectedPlan.dataset.planPrice}`;
    }
  });

  syncPurchaseType();
});

document.querySelectorAll('[data-henley-product]').forEach((henley) => {
  const root = henley.closest('[data-product-form-root]');
  const variantsScript = henley.querySelector('[data-henley-variants-json]');
  const variantInput = henley.querySelector('[data-henley-variant-id]');
  const colorOptions = Array.from(henley.querySelectorAll('[data-henley-color-option]'));
  const sizeOptions = Array.from(henley.querySelectorAll('[data-henley-size-option]'));
  const selectedColor = henley.querySelector('[data-henley-selected-color]');
  const price = henley.querySelector('[data-product-price]');
  const comparePrice = henley.querySelector('[data-product-compare-price]');
  const addButton = henley.querySelector('[data-add-to-cart]');
  const sku = henley.querySelector('[data-product-sku]');
  const quantity = henley.querySelector('[data-henley-quantity]');
  const quantityMinus = henley.querySelector('[data-henley-quantity-minus]');
  const quantityPlus = henley.querySelector('[data-henley-quantity-plus]');

  if (!variantsScript || !variantInput) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    return;
  }

  const getOptionValue = (variant, index) => variant.options?.[index] || variant[`option${index + 1}`];

  const updateHenleyVariant = () => {
    const color = colorOptions.find((option) => option.checked)?.value;
    const size = sizeOptions.find((option) => option.checked)?.value;
    const variant = variants.find((item) => (
      (!color || getOptionValue(item, 0) === color)
      && (!size || getOptionValue(item, 1) === size)
    ));

    if (!variant) {
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
      }
      return;
    }

    variantInput.value = variant.id;
    if (selectedColor && color) selectedColor.textContent = color;

    if (price && Number.isFinite(variant.price)) {
      price.textContent = Shopify.formatMoney(variant.price, window.themeMoneyFormat || defaultMoneyFormat);
    }

    if (comparePrice) {
      const hasComparePrice = Number.isFinite(variant.compare_at_price)
        && variant.compare_at_price > variant.price;
      comparePrice.hidden = !hasComparePrice;
      comparePrice.textContent = hasComparePrice
        ? Shopify.formatMoney(variant.compare_at_price, window.themeMoneyFormat || defaultMoneyFormat)
        : '';
    }

    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available
        ? addButton.dataset.availableText
        : addButton.dataset.soldOutText;
    }

    if (sku) sku.textContent = variant.sku || 'Available at checkout';

    const selectedMediaId = variant.featured_media?.id || variant.featured_image?.id;
    if (selectedMediaId && root?.showGalleryMedia) root.showGalleryMedia(selectedMediaId);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  };

  colorOptions.forEach((option) => option.addEventListener('change', updateHenleyVariant));
  sizeOptions.forEach((option) => option.addEventListener('change', updateHenleyVariant));

  quantityMinus?.addEventListener('click', () => {
    if (!quantity) return;
    quantity.value = String(Math.max(Number(quantity.value || 1) - 1, 1));
  });

  quantityPlus?.addEventListener('click', () => {
    if (!quantity) return;
    quantity.value = String(Math.max(Number(quantity.value || 1) + 1, 1));
  });

  updateHenleyVariant();
});

document.querySelectorAll('[data-canvas-variant-picker]').forEach((picker) => {
  const context = picker.closest('[data-canvas-variant-context]');
  const root = picker.closest('[data-product-form-root]');
  const variantsScript = picker.querySelector('[data-canvas-variants-json]');
  const inventoryScript = picker.querySelector('[data-canvas-inventory-json]');
  const variantInput = picker.querySelector('[data-canvas-variant-id]');
  const colorOptions = Array.from(picker.querySelectorAll('[data-canvas-color-option]'));
  const sizeOptions = Array.from(picker.querySelectorAll('[data-canvas-size-option]'));
  const selectedColor = picker.querySelector('[data-canvas-selected-color]');
  const price = context?.querySelector('[data-product-price]');
  const comparePrice = context?.querySelector('[data-product-compare-price]');
  const addButton = context?.querySelector('[data-add-to-cart]');
  const sku = context?.querySelector('[data-product-sku]');
  const cardImage = context?.querySelector('.product-card__media img');
  const cardLinks = Array.from(context?.querySelectorAll('[data-canvas-card-link]') || []);
  const cardTitle = context?.querySelector('[data-canvas-card-title]');
  const titleBase = picker.dataset.variantTitleBase || 'Canvas Sneaker';

  if (!context || !variantsScript || !inventoryScript || !variantInput) return;

  let variants = [];
  let inventory = {};
  try {
    variants = JSON.parse(variantsScript.textContent);
    inventory = JSON.parse(inventoryScript.textContent);
  } catch (error) {
    return;
  }

  const getOptionValue = (variant, index) => variant.options?.[index] || variant[`option${index + 1}`];
  const findVariant = (color, size) => variants.find((variant) => (
    getOptionValue(variant, 0) === color && getOptionValue(variant, 1) === size
  ));

  const refreshSizes = (color) => {
    sizeOptions.forEach((option) => {
      const variant = findVariant(color, option.value);
      const stock = option.closest('label')?.querySelector('[data-canvas-size-stock]');
      const inventoryEntry = variant ? inventory[String(variant.id)] : null;
      const unavailable = !variant || !variant.available;

      option.disabled = unavailable;
      if (stock) {
        if (unavailable) {
          stock.textContent = 'Sold out';
        } else if (inventoryEntry?.tracked && inventoryEntry.quantity > 0 && inventoryEntry.quantity < 10) {
          stock.textContent = `${inventoryEntry.quantity} left`;
        } else {
          stock.textContent = '';
        }
      }
    });

    const selectedSize = sizeOptions.find((option) => option.checked && !option.disabled);
    if (!selectedSize) {
      const firstAvailableSize = sizeOptions.find((option) => !option.disabled);
      if (firstAvailableSize) firstAvailableSize.checked = true;
    }
  };

  const updateCanvasVariant = () => {
    const color = colorOptions.find((option) => option.checked)?.value;
    const size = sizeOptions.find((option) => option.checked)?.value;
    const variant = findVariant(color, size);

    if (!variant) {
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
      }
      return;
    }

    variantInput.value = variant.id;
    if (selectedColor && color) selectedColor.textContent = color;

    if (price && Number.isFinite(variant.price)) {
      price.textContent = Shopify.formatMoney(variant.price, window.themeMoneyFormat || defaultMoneyFormat);
    }

    if (comparePrice) {
      const hasComparePrice = Number.isFinite(variant.compare_at_price)
        && variant.compare_at_price > variant.price;
      comparePrice.hidden = !hasComparePrice;
      comparePrice.textContent = hasComparePrice
        ? Shopify.formatMoney(variant.compare_at_price, window.themeMoneyFormat || defaultMoneyFormat)
        : '';
    }

    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available
        ? addButton.dataset.availableText
        : addButton.dataset.soldOutText;
    }

    if (sku) sku.textContent = variant.sku || 'Available at checkout';

    const selectedMediaId = variant.featured_media?.id || variant.featured_image?.id;
    if (selectedMediaId && root?.showGalleryMedia) root.showGalleryMedia(selectedMediaId);

    if (cardImage && variant.featured_image?.src) {
      cardImage.src = variant.featured_image.src;
      cardImage.removeAttribute('srcset');
      cardImage.alt = `${titleBase} - ${color}`;
    }

    cardLinks.forEach((link) => {
      const linkUrl = new URL(link.href, window.location.origin);
      const productPath = picker.dataset[`${String(color).toLowerCase()}ProductPath`];
      if (productPath) linkUrl.pathname = productPath;
      linkUrl.searchParams.set('variant', variant.id);
      link.href = linkUrl.toString();
      link.setAttribute('aria-label', `${titleBase} - ${color}`);
      if (link === cardTitle) link.textContent = `${titleBase} - ${color}`;
    });

    if (picker.classList.contains('canvas-pdp-picker')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  colorOptions.forEach((option) => {
    option.addEventListener('change', () => {
      refreshSizes(option.value);
      updateCanvasVariant();
    });
  });
  sizeOptions.forEach((option) => option.addEventListener('change', updateCanvasVariant));

  const initialColor = colorOptions.find((option) => option.checked)?.value;
  if (initialColor) refreshSizes(initialColor);
  updateCanvasVariant();
});

document.querySelectorAll('[data-product-form-root]').forEach((root) => {
  const select = root.querySelector('[data-variant-select]');
  const variantOptions = Array.from(root.querySelectorAll('[data-variant-option]'));
  const price = root.querySelector('[data-product-price]');
  const comparePrice = root.querySelector('[data-product-compare-price]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const sku = root.querySelector('[data-product-sku]');
  const variantsScript = root.querySelector('[data-variants-json]');

  if ((!select && !variantOptions.length) || !variantsScript) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    return;
  }

  const updateVariant = (variantId) => {
    const selected = variants.find((variant) => String(variant.id) === String(variantId));
    if (!selected) return;

    if (price && Number.isFinite(selected.price)) {
      price.innerHTML = Shopify.formatMoney(selected.price, window.themeMoneyFormat || defaultMoneyFormat);
    }

    if (comparePrice) {
      const hasComparePrice = Number.isFinite(selected.compare_at_price)
        && selected.compare_at_price > selected.price;

      comparePrice.hidden = !hasComparePrice;
      comparePrice.innerHTML = hasComparePrice
        ? Shopify.formatMoney(selected.compare_at_price, window.themeMoneyFormat || defaultMoneyFormat)
        : '';
    }

    if (addButton) {
      addButton.disabled = !selected.available;
      addButton.textContent = selected.available ? addButton.dataset.availableText : addButton.dataset.soldOutText;
    }

    if (sku) sku.textContent = selected.sku || 'Available at checkout';

    const selectedMediaId = selected.featured_media?.id || selected.featured_image?.id;
    const didShowSelectedMedia = selectedMediaId && root.showGalleryMedia
      ? root.showGalleryMedia(selectedMediaId)
      : false;

    if (!didShowSelectedMedia && root.showGalleryVariant) {
      root.showGalleryVariant(selected.id);
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', selected.id);
    window.history.replaceState({}, '', url.toString());
  };

  if (select) {
    select.addEventListener('change', () => updateVariant(select.value));
  }

  variantOptions.forEach((option) => {
    option.addEventListener('change', () => {
      if (option.checked) updateVariant(option.value);
    });
  });
});

document.querySelectorAll('[data-collection-filter-root]').forEach((root) => {
  const items = Array.from(root.querySelectorAll('[data-collection-filter-item]'));
  const controls = Array.from(root.querySelectorAll('[data-filter-group]'));
  const clearButtons = Array.from(root.querySelectorAll('[data-filter-clear]'));
  const resultCount = root.querySelector('[data-filter-result-count]');
  const resultLabel = root.querySelector('[data-filter-result-label]');
  const activeCount = root.querySelector('[data-filter-active-count]');
  const emptyState = root.querySelector('[data-filter-empty]');
  const productGrid = root.querySelector('.product-grid');

  if (!items.length || !controls.length) return;

  const selectedValues = (group) => controls
    .filter((control) => control.dataset.filterGroup === group && control.checked)
    .map((control) => control.value.toLowerCase());

  const itemValues = (item, key) => String(item.dataset[key] || '')
    .toLowerCase()
    .split('|')
    .filter(Boolean);

  const filterKeys = {
    type: 'filterType',
    color: 'filterColors',
    material: 'filterMaterials',
    size: 'filterSizes',
    accessory: 'filterAccessories',
    benefit: 'filterBenefits'
  };

  const matchesSelections = (item, selections, ignoredGroup = '') => Object.entries(filterKeys)
    .every(([group, key]) => {
      if (group === ignoredGroup) return true;
      const values = selections[group];
      return !values.length || values.some((value) => itemValues(item, key).includes(value));
    });

  const applyFilters = () => {
    const selections = Object.keys(filterKeys).reduce((values, group) => {
      values[group] = selectedValues(group);
      return values;
    }, {});
    let visibleCount = 0;

    items.forEach((item) => {
      const isVisible = matchesSelections(item, selections);

      item.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    controls.forEach((control) => {
      const group = control.dataset.filterGroup;
      const key = filterKeys[group];
      const value = control.value.toLowerCase();
      const isAvailable = items.some((item) => (
        matchesSelections(item, selections, group) && itemValues(item, key).includes(value)
      ));
      const shouldHide = !isAvailable && !control.checked;
      const option = control.closest('.collection-filter-option');

      control.disabled = shouldHide;
      if (option) option.hidden = shouldHide;
    });

    const numberActive = controls.filter((control) => control.checked).length;
    if (resultCount) resultCount.textContent = String(visibleCount);
    if (resultLabel) resultLabel.textContent = visibleCount === 1 ? 'product' : 'products';
    if (activeCount) {
      activeCount.hidden = numberActive === 0;
      activeCount.textContent = numberActive ? String(numberActive) : '';
    }
    clearButtons.forEach((button) => { button.disabled = numberActive === 0; });
    if (emptyState) emptyState.hidden = visibleCount !== 0;
    if (productGrid) productGrid.classList.toggle('product-grid--single-card-result', visibleCount === 1);
  };

  controls.forEach((control) => control.addEventListener('change', applyFilters));
  clearButtons.forEach((button) => {
    button.addEventListener('click', () => {
      controls.forEach((control) => { control.checked = false; });
      applyFilters();
    });
  });

  applyFilters();
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const root = gallery.closest('[data-product-form-root]');
  const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
  const previous = gallery.querySelector('[data-gallery-previous]');
  const next = gallery.querySelector('[data-gallery-next]');
  const current = gallery.querySelector('[data-gallery-current]');
  const dialog = gallery.querySelector('[data-gallery-dialog]');
  const dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
  const dialogClose = gallery.querySelector('[data-gallery-dialog-close]');
  const dialogPrevious = gallery.querySelector('[data-gallery-dialog-previous]');
  const dialogNext = gallery.querySelector('[data-gallery-dialog-next]');

  if (!slides.length) return;

  let activeIndex = 0;

  const updateDialogImage = () => {
    if (!dialogImage) return;
    const activeSlide = slides[activeIndex];
    const activeImage = activeSlide?.querySelector('img');
    dialogImage.src = activeSlide?.dataset.fullImage || activeImage?.src || '';
    dialogImage.alt = activeImage?.alt || '';
  };

  const showSlide = (requestedIndex) => {
    activeIndex = (requestedIndex + slides.length) % slides.length;

    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.hidden = !isActive;
      slide.classList.toggle('is-active', isActive);
    });

    thumbnails.forEach((thumbnail, index) => {
      const isActive = index === activeIndex;
      thumbnail.classList.toggle('is-active', isActive);
      thumbnail.setAttribute('aria-selected', String(isActive));
      if (isActive) {
        thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });

    if (current) current.textContent = String(activeIndex + 1);
    if (dialog?.open) updateDialogImage();
  };

  const openDialog = () => {
    if (!dialog || !dialogImage) return;
    updateDialogImage();
    if (typeof dialog.showModal === 'function') dialog.showModal();
  };

  slides.forEach((slide) => slide.addEventListener('click', openDialog));
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', () => showSlide(index));
  });

  previous?.addEventListener('click', () => showSlide(activeIndex - 1));
  next?.addEventListener('click', () => showSlide(activeIndex + 1));
  dialogPrevious?.addEventListener('click', () => showSlide(activeIndex - 1));
  dialogNext?.addEventListener('click', () => showSlide(activeIndex + 1));
  dialogClose?.addEventListener('click', () => dialog.close());

  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  gallery.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
    if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
    if (event.key === 'Escape' && dialog?.open) dialog.close();
  });

  if (root) {
    root.showGalleryMedia = (mediaId) => {
      const mediaIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
      if (mediaIndex < 0) return false;
      showSlide(mediaIndex);
      return true;
    };

    root.showGalleryVariant = (variantId) => {
      const variantIndex = slides.findIndex((slide) => String(slide.dataset.variantId) === String(variantId));
      if (variantIndex < 0) return false;
      showSlide(variantIndex);
      return true;
    };

    const selectedVariantControl = root.querySelector('[data-variant-option]:checked, [data-variant-select]');
    selectedVariantControl?.dispatchEvent(new Event('change', { bubbles: true }));
  }
});
